import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8c6099e6")

_pushScopeId("data-v-8c6099e6")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Trade Now")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_SymbolLink = _resolveComponent("SymbolLink")
  const _component_Icon = _resolveComponent("Icon")
  const _component_TheTopic = _resolveComponent("TheTopic")
  const _component_PageWithHeader = _resolveComponent("PageWithHeader")

  return (_openBlock(), _createBlock(_component_PageWithHeader, null, _createSlots({
    title: _withId(() => [
      _createTextVNode("#" + _toDisplayString(_ctx.topic), 1)
    ]),
    default: _withId(() => [
      _createVNode(_component_TheTopic, { topic: _ctx.topic }, null, 8, ["topic"])
    ]),
    _: 2
  }, [
    (_ctx.showTradeBtn)
      ? {
          name: "right",
          fn: _withId(() => [
            _createVNode(_component_SymbolLink, {
              tag: "span",
              code: _ctx.topic,
              "with-history-back": "",
              class: "trade-btn v-middle"
            }, {
              default: _withId(() => [
                _createVNode(_component_t, {
                  path: "tag_2",
                  class: "c-primary f-md"
                }, {
                  default: _withId(() => [
                    _hoisted_1
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["code"]),
            _createVNode(_component_Icon, {
              name: "close",
              class: "c-title anchor",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back()))
            })
          ])
        }
      : undefined
  ]), 1024))
})